import { SelectorStatus } from '../components/CampaignAndGroupSelector/CampaignAndGroupSelector';
import { SelectorItems } from '../components/CampaignAndGroupSelector/Selector/Selector';
import { CampaignAndGroupSelectorEntityToSelectType } from '../typings/state';

export const FETCH_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA =
    'FETCH_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA';
export type FETCH_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA = typeof FETCH_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA;
export const FETCH_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA =
    'FETCH_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA';
export type FETCH_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA = typeof FETCH_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA;
export const CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS =
    'CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS';
export type CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS = typeof CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS;
export const SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN =
    'SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN';
export type SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN = typeof SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN;
export const SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP =
    'SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP';
export type SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP = typeof SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP;
export const UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA =
    'UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA';
export type UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA = typeof UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA;
export const UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA =
    'UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA';
export type UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA = typeof UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA;
export const ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA =
    'ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA';
export type ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA = typeof ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA;
export const OPEN_CAMPAIGN_AND_GROUP_SELECTOR =
    'OPEN_CAMPAIGN_AND_GROUP_SELECTOR';
export type OPEN_CAMPAIGN_AND_GROUP_SELECTOR = typeof OPEN_CAMPAIGN_AND_GROUP_SELECTOR;
export const CLOSE_CAMPAIGN_AND_GROUP_SELECTOR =
    'CLOSE_CAMPAIGN_AND_GROUP_SELECTOR';
export type CLOSE_CAMPAIGN_AND_GROUP_SELECTOR = typeof CLOSE_CAMPAIGN_AND_GROUP_SELECTOR;

export interface FetchCampaignAndGroupSelectorCampaignsData {
    type: FETCH_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA;
    filter: string;
}

export function fetchCampaignAndGroupSelectorCampaignsData(
    filter: string
): FetchCampaignAndGroupSelectorCampaignsData {
    return {
        type: FETCH_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA,
        filter
    };
}

export interface FetchCampaignAndGroupSelectorGroupsData {
    type: FETCH_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA;
    filter: string;
}

export function fetchCampaignAndGroupSelectorGroupsData(
    filter: string
): FetchCampaignAndGroupSelectorGroupsData {
    return {
        type: FETCH_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA,
        filter
    };
}

export interface ChangeCampaignsAndGroupSelectorStatus {
    type: CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS;
    selectorStatus: SelectorStatus;
}

export function changeCampaignsAndGroupSelectorStatus(
    selectorStatus: SelectorStatus
): ChangeCampaignsAndGroupSelectorStatus {
    return {
        type: CHANGE_CAMPAIGN_AND_GROUP_SELECTOR_STATUS,
        selectorStatus
    };
}

export interface SelectCampaignAndGroupSelectorCampaign {
    type: SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN;
    campaignSelected?: SelectorItems;
}

export function selectCampaignAndGroupSelectorCampaign(
    campaignSelected?: SelectorItems
): SelectCampaignAndGroupSelectorCampaign {
    return {
        type: SELECT_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGN,
        campaignSelected
    };
}

export interface SelectCampaignAndGroupSelectorGroup {
    type: SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP;
    groupSelected?: SelectorItems;
}

export function selectCampaignAndGroupSelectorGroup(
    groupSelected?: SelectorItems
): SelectCampaignAndGroupSelectorGroup {
    return {
        type: SELECT_CAMPAIGN_AND_GROUP_SELECTOR_GROUP,
        groupSelected
    };
}

export interface UpdateCampaignAndGroupSelectorCampaignsData {
    type: UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA;
    campaignItems: Array<SelectorItems>;
}

export function updateCampaignAndGroupSelectorCampaignsData(
    campaignItems: Array<SelectorItems>
): UpdateCampaignAndGroupSelectorCampaignsData {
    return {
        type: UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_CAMPAIGNS_DATA,
        campaignItems
    };
}

export interface UpdateCampaignAndGroupSelectorGroupsData {
    type: UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA;
    groupItems: Array<SelectorItems>;
}

export function updateCampaignAndGroupSelectorGroupsData(
    groupItems: Array<SelectorItems>
): UpdateCampaignAndGroupSelectorGroupsData {
    return {
        type: UPDATE_CAMPAIGN_AND_GROUP_SELECTOR_GROUPS_DATA,
        groupItems
    };
}

export interface AcceptCampaignAndGroupSelectorData {
    type: ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA;
}

export function acceptCampaignAndGroupSelectorData(): AcceptCampaignAndGroupSelectorData {
    return {
        type: ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA
    };
}

export const ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA_DNA =
    'ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA_DNA';
export type ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA_DNA = typeof ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA_DNA;

export interface AcceptCampaignAndGroupSelectorDataDnaAction {
    type: ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA_DNA;
}

export function acceptCampaignAndGroupSelectorDataDna(): AcceptCampaignAndGroupSelectorDataDnaAction {
    return {
        type: ACCEPT_CAMPAIGN_AND_GROUP_SELECTOR_DATA_DNA
    };
}

export interface OpenCampaignAndGroupSelector {
    type: OPEN_CAMPAIGN_AND_GROUP_SELECTOR;
    entityToSelectType: CampaignAndGroupSelectorEntityToSelectType;
}

export function openCampaignAndGroupSelector(
    entityToSelectType: CampaignAndGroupSelectorEntityToSelectType
): OpenCampaignAndGroupSelector {
    return {
        type: OPEN_CAMPAIGN_AND_GROUP_SELECTOR,
        entityToSelectType
    };
}

export interface CloseCampaignAndGroupSelector {
    type: CLOSE_CAMPAIGN_AND_GROUP_SELECTOR;
}

export function closeCampaignAndGroupSelector(): CloseCampaignAndGroupSelector {
    return {
        type: CLOSE_CAMPAIGN_AND_GROUP_SELECTOR
    };
}

export const OPEN_CAMPAIGN_TYPES_MENU = 'OPEN_CAMPAIGN_TYPES_MENU';
export type OPEN_CAMPAIGN_TYPES_MENU = typeof OPEN_CAMPAIGN_TYPES_MENU;

export interface OpenCampaignTypesMenu {
    type: OPEN_CAMPAIGN_TYPES_MENU;
}

export function openCampaignTypesMenu(): OpenCampaignTypesMenu {
    return {
        type: OPEN_CAMPAIGN_TYPES_MENU
    };
}

export type CampaignAndGroupSelectorActions =
    | FetchCampaignAndGroupSelectorCampaignsData
    | FetchCampaignAndGroupSelectorGroupsData
    | ChangeCampaignsAndGroupSelectorStatus
    | SelectCampaignAndGroupSelectorCampaign
    | SelectCampaignAndGroupSelectorGroup
    | UpdateCampaignAndGroupSelectorCampaignsData
    | AcceptCampaignAndGroupSelectorData
    | AcceptCampaignAndGroupSelectorDataDnaAction
    | OpenCampaignAndGroupSelector
    | CloseCampaignAndGroupSelector
    | OpenCampaignTypesMenu
    | UpdateCampaignAndGroupSelectorGroupsData;
